import React, { useEffect, useState } from "react";
import "../Styles/blogdetails.css";
import Navbar from "../sections/common/Navbar";
import Footer from "../sections/common/Footer";
import { FaRegUserCircle } from "react-icons/fa";
import { SlCalender } from "react-icons/sl";
import Pagination from "../sections/common/Pagination";
import { blogListApi } from "../apis/blog/blogApis";
import { categoryListApi } from "../apis/propertylisting/propertyListApi";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function BlogDetails() {
  const navigate = useNavigate();
  const [blogList, setBlogList] = useState(null);
  const [filteredBlogList, setFilteredBlogList] = useState(null);
  const [topArticles, setTopArticles] = useState(null);
  const [categoryData, setCategoryData] = useState(null);

  const fetchBlogList = async () => {
    const response = await blogListApi();
    console.log(response);
    setTopArticles(response?.top);
    setBlogList(response?.data?.data);
    setFilteredBlogList(response?.data?.data);
  };

  const fetchCategoryList = async () => {
    const response = await categoryListApi();
    const categoryList = response?.data?.data;
    setCategoryData(categoryList);
  };

  useEffect(() => {
    fetchBlogList();
    fetchCategoryList();
  }, []);

  const handleCategory = (id) => {
    const data = blogList?.filter((item) => item.category_id == id);
    setFilteredBlogList(data);
    console.log(data);
  };

  return (
    <>
      <div className="blog_details">
        <Navbar />
        <section className="listing-banner">
          <h1>Blogs</h1>
        </section>
        <section className="container blog-details-page-location">
          <p>Home / Blogs</p>
        </section>

        <section className="container ">
          <div className="row pt-4">
            <div className="col-sm-12 col-xxl-8">
              {filteredBlogList &&
                filteredBlogList?.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="blog_main_section"
                      onClick={() =>
                        navigate(`/blog-detail/${item.slug}-${item.id}`)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={item?.image || "/images/blog_image.png"}
                        alt="image"
                      />
                      <div className="px-3">
                        <div className="blog-detail-title d-flex align-items-center justify-content-between my-3">
                          <p className="m-0 p-0 blog_main_section_btn">
                            Property
                          </p>
                          <div className="d-flex align-items-center justify-content-between blog_main_section_date  ">
                            <div className="blog_main_section_date-top d-flex align-items-center mx-2">
                              <FaRegUserCircle className="mx-2" />
                              <p className="m-0 p-0">{item?.name}</p>
                            </div>
                            <div className="blog_main_section_date-btn d-flex align-items-center">
                              <SlCalender className="mx-2" />
                              <p className="m-0 p-0">{item?.created}</p>
                            </div>
                          </div>
                        </div>
                        <div className="blog_main_title">
                          <h3>{item?.title}</h3>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="col-sm-12 col-xxl-4">
              {/* <div className="blog_details_search_section">
                                <h3>Search</h3>
                                <input type="text" placeholder='Search' />
                            </div> */}
              <div className="blog_details_categories_section">
                <h3>Categories</h3>
                <ul>
                  <li onClick={() => fetchBlogList()}>All</li>
                  {categoryData &&
                    categoryData?.category?.map((item, i) => (
                      <li onClick={() => handleCategory(item.id)}>
                        {item.category_name}
                      </li>
                    ))}
                </ul>
              </div>

              <div className="blog_details_top_article_section">
                <h3>Top Articles</h3>
                {topArticles &&
                  topArticles?.map((item, i) => {
                    return (
                      <div key={i} className="d-flex align-items-center my-3">
                        <img src="/images/image1.jpg" alt="image" />
                        <h4>Excited News About Buildings</h4>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Pagination />
      <Footer />
    </>
  );
}

export default BlogDetails;
